import { inputPadding } from './inputPadding'
import { baseInput } from './baseInput'

export default {
  ...baseInput,
  ...inputPadding
}
